import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ButtonModule } from 'primeng/button'
import { TimeframePickerComponent } from './timeframe-picker.component'
import { InputMaskModule } from 'primeng/inputmask'

@NgModule({
  declarations: [TimeframePickerComponent],
  imports: [CommonModule, ButtonModule, InputMaskModule, FormsModule],
  exports: [TimeframePickerComponent],
})
export class TimeframePickerModule {}
